import script from "./WapEducationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapEducationView.vue?vue&type=script&lang=ts&setup=true"

import "./WapEducationView.vue?vue&type=style&index=0&id=115a00ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115a00ce"]])

export default __exports__